import { render, staticRenderFns } from "./SpacerComponent.vue?vue&type=template&id=bffca1f4&scoped=true"
import script from "./SpacerComponent.vue?vue&type=script&lang=js"
export * from "./SpacerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffca1f4",
  null
  
)

export default component.exports